import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/context/AuthContext';
import { PageContainer } from '@/components/layout/PageContainer';
import Logger from '@/utils/logger';

const AuthCallback = () => {
  const navigate = useNavigate();
  const { isOnboardingRequired, isLoading } = useAuth();

  useEffect(() => {
    if (isLoading) {
      return;
    }

    const handleAuthCallback = async () => {
      try {
        const { data: { session }, error } = await supabase.auth.getSession();
        
        if (error) {
          Logger.error('Auth session error', error, { component: 'AuthCallback' });
          throw error;
        }
        
        if (session) {
          const destination = isOnboardingRequired ? '/onboarding' : '/dashboard';
          navigate(destination, { replace: true });
        } else {
          navigate('/');
        }
      } catch (error) {
        Logger.error('Error during auth callback', error instanceof Error ? error : new Error(String(error)), {
          component: 'AuthCallback'
        });
        navigate('/');
      }
    };

    handleAuthCallback();
  }, [navigate, isOnboardingRequired, isLoading]); // Add isLoading to dependencies

  return (
    <PageContainer title="Authenticating..." subtitle="Please wait">
      <div className="flex justify-center items-center h-[50vh]">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    </PageContainer>
  );
};

export default AuthCallback;
